import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';
import createPersistedState from 'vuex-persistedstate';

import appConfig from './app.config';
import { Api } from './api';

Vue.use(Vuex);

/* eslint no-param-reassign: 0, no-shadow: 0 */

export default new Vuex.Store({
  state: {
    postOffices: [],
    postOfficesGrouped: null,
  },
  getters: {
    postOfficeDistricts: state => _.map(state.postOffices, 'index_name'),
  },
  mutations: {
    receivePostOffice(s, data) {
      s.postOffices = [...data];
      s.postOfficesGrouped = _.groupBy(data, 'index_name');
    },
  },
  actions: {
    fetchPostOffices({ commit }) {
      return Api.app.postOffice().then(({ data: response }) => {
        commit('receivePostOffice', response.data);
      });
    },
  },
  plugins: [
    createPersistedState({
      key: appConfig.VUEX_STORE_KEY,
      storage: appConfig.VUEX_STORE_STORAGE,
      reducer: (persistedState) => {
        const stateFilter = _.cloneDeep(persistedState);
        [
          //
        ].forEach(key => _.unset(stateFilter, key));
        return stateFilter;
      },
    }),
  ],
});
